import React, { useEffect, useState } from 'react';
import { Loader2, ExternalLink, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Bank } from '@phosphor-icons/react';
import client from '../../api/client';
import AppIcon from '../AppIcon';

export const PayoutSetupCard = ({ slug, toast }) => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [blocked, setBlocked] = useState('');
  useEffect(() => { client.get('/gifts/connect/status').then(({ data }) => setSt(data)).catch(() => setSt({})); }, []);

  const start = async () => {
    setBusy(true); setBlocked('');
    try {
      const { data } = await client.post('/gifts/connect/onboard', { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      if (e.code === 'connect_not_enabled') setBlocked(e.message);
      else toast?.({ title: 'Could not start payout setup', description: e.message, variant: 'destructive' });
      setBusy(false);
    }
  };

  if (!st) return null;
  return (
    <section data-testid="payout-setup-card" className="soft-card bg-white rounded-2xl border border-[#EFE3D8] p-5 flex flex-col sm:flex-row gap-4 sm:items-center">
      <AppIcon icon={Bank} tone="sage" size="lg" reveal />
      <div className="flex-1">
        <h2 className="font-serif text-xl text-[#2A2A2A]">Card gifts & payouts</h2>
        {st.ready ? (
          <p data-testid="payout-ready" className="text-sm text-[#2E7D32] inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4" /> Ready. Guests can pay by card and money goes straight to your bank. We take no fee.</p>
        ) : (
          <p className="text-sm text-[#6A6A6A]">Set up your payout account once (about 5 minutes with Stripe). Your funds and group gifts start accepting card gifts as soon as you finish. We take no fee.</p>
        )}
        {st.mode === 'test' && <p className="text-[11px] text-[#B45309] mt-1">Test mode: no real money moves. Use card 4242 4242 4242 4242.</p>}
        {blocked && <p data-testid="payout-blocked" className="text-xs text-[#B45309] mt-2 inline-flex items-center gap-1.5"><AlertTriangle className="w-3.5 h-3.5" /> {blocked}</p>}
      </div>
      <div className="flex flex-col gap-2 items-start sm:items-end">
        {!st.ready && (
          <button data-testid="payout-setup-btn" onClick={start} disabled={busy} className="btn-primary text-xs px-4 py-2 rounded-full inline-flex items-center gap-1.5 disabled:opacity-50">
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} {st.connected ? 'Finish payout setup' : 'Set up payouts'}
          </button>
        )}
        {slug && <a data-testid="gift-page-link" href={`/gifts/${slug}`} target="_blank" rel="noreferrer" className="text-xs text-[#7B2C3B] inline-flex items-center gap-1 hover:underline">View guest gift page <ExternalLink className="w-3 h-3" /></a>}
      </div>
    </section>
  );
};

export default PayoutSetupCard;
